var React = require('react');

function CriticalLow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M17.6618 3.60164L11.1078 14.8011C10.1744 16.3996 7.82561 16.3996 6.88199 14.8011L0.327979 3.60164C-0.60538 2.00316 0.56388 -1.52431e-06 2.44085 -1.36022e-06L15.5592 -2.13386e-07C17.4361 -4.92958e-08 18.6054 2.00316 17.672 3.60164L17.6618 3.60164Z","fill":"#E34325"}));
}

CriticalLow.defaultProps = {"width":"18","height":"16","viewBox":"0 0 18 16","fill":"none"};

module.exports = CriticalLow;

CriticalLow.default = CriticalLow;
